// extracted by mini-css-extract-plugin
export var pillWrapper = "_nx-0";
export var showOverflow = "_nx-1";